const ConfigApp = {
  app_name: "LINE OA Service System",
};

export default ConfigApp;
